var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.contentAssistEnabled,
              expression: "contentAssistEnabled"
            }
          ],
          staticClass: "content-assist"
        },
        [
          _vm._v(
            "\n        " +
              _vm._s(_vm.bundleName) +
              " / " +
              _vm._s(_vm.itemKey) +
              "\n    "
          )
        ]
      ),
      _vm._v(" "),
      _c("span", { domProps: { innerHTML: _vm._s(_vm.contentToDisplay) } }),
      _vm._v(" "),
      _vm.appendHtml
        ? [_c("span", { domProps: { innerHTML: _vm._s(_vm.appendHtml) } })]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-40dbe6c2", { render: render, staticRenderFns: staticRenderFns })
  }
}